import { ContractNavigationEnum } from 'v3/data/store/contractCard/enum';

export const contractNavigationSteps: ContractNavigationEnum[] = [
  ContractNavigationEnum.INITIAL,
  ContractNavigationEnum.TOKEN_REQUESTED,
  ContractNavigationEnum.TOKEN_VERIFIED,
  ContractNavigationEnum.DEVICE_DETAILS,
  ContractNavigationEnum.SIGN_CONTRACT,
  ContractNavigationEnum.CONTRACT_COMPLETED,
];

export interface IContractNavigationState {
  currentStep: ContractNavigationEnum;
}
